import { render, staticRenderFns } from "./updateUserOrder.vue?vue&type=template&id=651ae7a0&"
import script from "./updateUserOrder.vue?vue&type=script&lang=js&"
export * from "./updateUserOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports